import { useMemo } from 'react';
import { useMyDataQuery } from '@/generated/graphql';
import { isPaidSubscription } from './isPaidSubscription';

/** Same myData fetch pattern as `useHasFeature`, but for "any paid plan"
 * (Starter/Plus/Pro+) rather than a specific plan feature. */
export const useIsPaidSubscriber = (): boolean => {
  const { data: myData } = useMyDataQuery();

  return useMemo(
    () => isPaidSubscription(myData?.myData?.subscription),
    [myData?.myData?.subscription],
  );
};
